(function () {
  function init() {
    var mainEl = document.querySelector('.js-media-list');
    if (!mainEl) return;

    if (mainEl.swiper) mainEl.swiper.destroy(true, true);

    var subEl = document.querySelector('.js-media-sublist');
    if (subEl && subEl.swiper) subEl.swiper.destroy(true, true);

    if (subEl) {
      new Swiper(subEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }

    var prevBtn = mainEl.querySelector('.swiper-btn--prev');
    var nextBtn = mainEl.querySelector('.swiper-btn--next');

    var mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      navigation: (prevBtn && nextBtn) ? { prevEl: prevBtn, nextEl: nextBtn } : false,
    });

    if (subEl) {
      subEl.querySelectorAll('.swiper-slide').forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          mainSwiper.slideTo(i);
        });
      });
      mainSwiper.on('slideChange', function () {
        if (subEl.swiper) subEl.swiper.slideTo(mainSwiper.realIndex);
      });
    }
  }

  init();
  document.addEventListener('shopify:section:load', init);
})();
